import { Row, Button, message } from "antd";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../../utils/HTTPClient";
import numeral from "numeral";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DomainPurchaseInfo = ({ foundDomain, setFoundDomain }) => {
    const [buying, setBuying] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const checkForPayment = async () => {
            const success = searchParams.get("success");
            if (success) {
                message.success(t("domains.purchase.success"));
            }
            setSearchParams("");
        };
        checkForPayment();
    }, []);

    const buyDomain = async () => {
        setBuying(true);
        try {
            await HTTPClient.post("/stripe/create_domain_checkout_session", {
                domain: foundDomain.domain,
            });
            message.success(t("domains.purchase.success"));
            navigate("/pro/domains");
        } catch (e) {
            // redirect to checkout portal
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                setBuying(false);
                return;
            }
            if (e.response.status === 412) {
                message.error(t("domains.purchase.profile_check"));
                setBuying(false);
                return;
            }
            const { error_code } = e?.response?.data;
            message.error(t([`errors.${error_code}`, "domains.purchase.error"]));
        }
        setBuying(false);
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (!foundDomain) return null;

    if (!foundDomain.available) {
        setFoundDomain(null);
        message.error(t("domains.purchase.not_available"));
        return null;
    }

    return (
        <>
            <Row
                style={{
                    width: "100%",
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                }}>
                <Button
                    onClick={() => buyDomain()}
                    type="primary"
                    loading={buying}
                    size="large"
                    style={{
                        width: isLargeScreen ? "" : "100%",
                    }}>
                    {t("domains.purchase.buy")} €{" "}
                    <span
                        style={{
                            fontWeight: "300",
                            fontSize: "large",
                            marginRight: "5px",
                        }}>
                        {numeral(foundDomain.price / 100).format("0,0.00")}
                    </span>{" "}
                    (1 {t("domains.purchase.year")})
                </Button>
            </Row>
        </>
    );
};

export { DomainPurchaseInfo };
